























import { defineComponent, reactive, ref } from '@vue/composition-api'
import Layout from '@/components/organisms/common/Layout.vue'
import PageDetailTable from '@/components/organisms/questionnaire/PageDetailTable.vue'
import { useUser } from '@/composable/common/useUser'
import { useQuestionnaireLoading } from '@/composable/questionnaire/useQuestionnaireLoading'
import useVuex from '@/utils/useVuex'
import { IPage } from '@/types/questionnaire'

export default defineComponent({
  name: 'EditQuestionnairePage',
  components: { Layout, PageDetailTable },
  setup(props, context) {
    const root = context.root
    const pageId = parseInt(root.$route.params.pageId)
    const { user } = useUser(context)
    const { isLoading } = useQuestionnaireLoading(context)

    const state = reactive({
      page: useVuex<IPage>(context, () =>
        root.$store.getters['questionnaire/page'](pageId),
      ),
    })

    const snackbar = ref({
      snackbar: false,
      message: '',
    })

    const save = async (body: {
      sentence: string
      htmlContent: string
      image: string
    }) => {
      try {
        await context.root.$store.dispatch(
          'questionnaire/updateQuestionnairePage',
          {
            pageId,
            ...body,
          },
        )
        context.root.$router.go(-1)
      } catch {
        snackbar.value.snackbar = true
        snackbar.value.message = 'エラーが発生しました。'
      }
    }

    const cancel = () => {
      const path = context.root.$route.path.replace(/page\/\d+\/edit/, 'detail')
      context.root.$router.push(path)
    }

    return { user, snackbar, state, isLoading, save, cancel }
  },
})
